import React from 'react';
import { Provider } from 'react-redux';
import DocumentTitle from 'react-document-title';
import { ConfigProvider } from 'antd';
import moment from 'moment';
import trMoment from 'moment/locale/tr';
import trAntd from 'antd/es/locale/tr_TR';
import enAntd from 'antd/es/locale/en_US';

import Router from './router';
import AppStore from '../store/AppStore';
import Header from './partials/Header';
import Navigation from './partials/Navigation';

const $PLA = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/app`);

class Main extends React.Component {
  state = {
    antdLocale: null,
  };

  componentDidMount() {
    this.setLocale();
  }

  setLocale = () => {
    if ($PLA.ANTD_LOCALE === 'tr') {
      this.setState({ antdLocale: trAntd });
      moment.locale('tr', trMoment);
    } else {
      this.setState({ antdLocale: enAntd });
      moment.locale('en');
    }
  };

  render() {
    const { antdLocale } = this.state;
    return (
      <DocumentTitle title={$PLA.TITLE}>
        <Provider store={AppStore}>
          <ConfigProvider locale={antdLocale}>
            <div>
              <Navigation />
              <div id='js-document-wrapper' className='document'>
                <Header key={window.location.pathname === '/home'} />
                <Router store={AppStore} />
              </div>
            </div>
          </ConfigProvider>
        </Provider>
      </DocumentTitle>
    );
  }
}

export default Main;



// WEBPACK FOOTER //
// ./src/components/main.js